import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_time_picker = _resolveComponent("el-time-picker");
  var _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_cache[2] || (_cache[2] = _createElementVNode("div", null, "这是菜单", -1)), _createVNode(_component_el_time_picker, {
    modelValue: _ctx.value1,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.value1 = $event),
    "disabled-hours": _ctx.disabledHours,
    "disabled-minutes": _ctx.disabledMinutes,
    "disabled-seconds": _ctx.disabledSeconds,
    placeholder: "任意时间点"
  }, null, 8, ["modelValue", "disabled-hours", "disabled-minutes", "disabled-seconds"]), _createVNode(_component_el_button, {
    type: "success"
  }, {
    default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("成功按钮")])),
    _: 1
  })], 64);
}